module.exports = __webpack_public_path__ + "static/img/92-1.eccd38a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/92-1.jpg
// module id = WYGy
// module chunks = 0